import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export const InstanceIdentifierInterceptorSkipHeader = 'X-Skip-InstanceIdentifierInterceptor';

@Injectable()
export class InstanceIdentifierInterceptor implements HttpInterceptor {

    constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(InstanceIdentifierInterceptorSkipHeader)) {
      const headers = request.headers.delete(InstanceIdentifierInterceptorSkipHeader);
      return next.handle(request.clone({ headers }));
    }

    request = request.clone({
      setHeaders: {
        'X-InstanceIdentifier': location.pathname.split('/')[1]
      },
      withCredentials: true
    });
    return next.handle(request);
  }
}
